<template>
  <FlexCol class="bg-white rounded-lg overflow-hidden">
    <Flex items-center justify-between class="bg-white border-b border-slate-300 py-4">
      <Flex gap-2 items-center>
        <span class="text-xs text-gray-700">Código:</span>
        <span class="text-gray-900 font-semibold">{{ formatCode(item.id) }}</span>
      </Flex>
      <FlexCol gap-2 items-start>
        <span class="text-gray-700 text-xs">Data Lançamento:</span>
        <span class="text-gray-900 font-semibold">{{ formatFullDate(item.date) }}</span>
      </FlexCol>
    </Flex>
    <Flex justify-between gap-6 class="py-4 border-b border-slate-300">
      <FlexCol gap-2 class="">
        <span v-if="!application" class="text-gray-700 text-xs">Local Origem:</span>
        <span v-if="application" class="text-gray-700 text-xs">Equipe:</span>
        <span class="text-gray-900 font-semibold">{{ item.originName }}</span>
      </FlexCol>
      <FlexCol gap-2 class="" v-if="!application">
        <span class="text-gray-700 text-xs">Local Destino:</span>
        <span class="text-gray-900 font-semibold">{{ item.destinationName }}</span>
      </FlexCol>
      <FlexCol gap-2 class="" :justifyEnd="application">
        <span class="text-gray-700 text-xs">Protocolo:</span>
        <span class="text-gray-900 font-semibold">{{ formatProtocol(item.orderProtocol) }}</span>
      </FlexCol>
    </Flex>
    <FlexCol class="py-4">
      <Accordion title="Materiais">
        <FlexCol>
          <span v-if="showCorrectionDetails" class="py-2">Original</span>
          <TheTable dense :headers="materialsHeaders" :items="originalItems" :disablePagination="true">
            <template #quantity="{ item }">
              {{ formatQuantity(item.quantity) }}
            </template>
          </TheTable>
        </FlexCol>
        <FlexCol>
          <span v-if="showCorrectionDetails" class="py-2">{{ props.application ? 'Correção' : (item.correction?.typeName || item.typeName) }}</span>
          <TheTable v-if="showCorrectionDetails" dense :headers="materialsHeaders" :items="correctionItems" :disablePagination="true">
            <template #quantity="{ item }">
              {{ formatQuantity(item.quantity) }}
            </template>
          </TheTable>
        </FlexCol>
      </Accordion>
    </FlexCol>
  </FlexCol>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useFormat } from '@/composables/useFormat'

const { formatCode, formatFullDate, formatQuantity, formatProtocol } = useFormat()

// Props
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  application: {
    type: Boolean,
    default: false,
  },
})

// Variables
const materialsHeaders = ref([
  { title: 'Código', field: 'code', disableOrder: true },
  { title: 'Item', field: 'name', disableOrder: true },
  { title: 'Quantidade', field: 'quantity', disableOrder: true },
])

const isCorrectionType = computed(() => ['applicationCorrection', 'downwardCorrection', 'correction'].includes(props.item?.type))

const originalItems = computed(() => {
  if (!isCorrectionType.value) {
    return props.item?.items || []
  }

  return props.item?.original?.items || []
})

const correctionItems = computed(() => {
  if (!isCorrectionType.value) {
    return props.item?.correction?.items || []
  }

  return props.item?.items || []
})

const showCorrectionDetails = computed(() => {
  if (!isCorrectionType.value) {
    return !!(props.item?.idOriginalMovement || props.item?.correction)
  }

  return !!props.item?.original
})
</script>
